import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["title", "aria-label", "onClick"]
const _hoisted_2 = { class: "bg-white py-6 px-8 rounded-xl w-[900px] max-w-[50vw]" }
const _hoisted_3 = { class: "text-xl font-semibold mb-6" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "flex space-x-4 mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_CloseModalButton = _resolveComponent("CloseModalButton")!
  const _component_ContentOptionsSelector = _resolveComponent("ContentOptionsSelector")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "close-esc-event": "keydown",
    "close-button": false,
    "modal-class": "m-auto border-0",
    size: "max-w-4xl",
    "mask-class": "grid",
    onOpening: _ctx.onOpen,
    onClosing: _ctx.onClose
  }, {
    toggle: _withCtx((scope) => [
      _createElementVNode("button", {
        type: "button",
        class: "inline-flex items-center justify-center h-12 w-12 text-primary-700 hover:text-primary-800 transition-colors",
        title: _ctx.$t('views.reports.selectContentOptionsPage.header'),
        "aria-label": _ctx.$t('views.reports.selectContentOptionsPage.header'),
        onClick: scope.open
      }, [
        _createVNode(_component_Icon, {
          src: _ctx.IconSource.ContentOptions,
          class: "w-8 h-8"
        }, null, 8, ["src"])
      ], 8, _hoisted_1)
    ]),
    header: _withCtx((scope) => [
      _createVNode(_component_CloseModalButton, {
        onClose: scope.close
      }, null, 8, ["onClose"])
    ]),
    body: _withCtx((scope) => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('views.reports.selectContentOptionsPage.header')), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.localState)
            ? (_openBlock(), _createBlock(_component_ContentOptionsSelector, {
                key: 0,
                state: _ctx.localState,
                "content-options": _ctx.state.contentOptions,
                "auto-select-all": true,
                "max-height-class": "max-h-[53rem]"
              }, null, 8, ["state", "content-options"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_CustomButton, {
            class: "flex-1",
            "color-preset": "secondary",
            onClick: ($event: any) => (_ctx.onCancel(scope.close))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.cancelButton')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_CustomButton, {
            class: "flex-1",
            disabled: _ctx.isSaveDisabled,
            onClick: ($event: any) => (_ctx.onSave(scope.close))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.reports.reportsPage.approveDifferenceModal.saveButton')), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOpening", "onClosing"]))
}